import { writable } from 'svelte/store';
import { subscribe } from 'svelte/internal';
import localAzucarOptions from '../localAzucarOptions.js'
// const store = writable(flattenMachines([...localAzucarOptions]));
const store = writable(flattenMachines([...localAzucarOptions]));

//set
// subscribe
// update

function flattenMachines(data) {
    return data.map((item) => {
        return { ...item }
    })
}

export default store;